interface Props {
  sqlSetup: string;
}

export function SqlSchemaPanel({ sqlSetup }: Props) {
  return (
    <div className="flex flex-col gap-3 p-4">
      <div className="text-sm font-semibold text-foreground">Schema</div>
      {sqlSetup ? (
        <pre className="rounded bg-muted px-3 py-2 font-mono text-sm whitespace-pre-wrap overflow-x-auto">
          {sqlSetup}
        </pre>
      ) : (
        <div className="text-sm text-muted-foreground">Schema not available for this problem.</div>
      )}
    </div>
  );
}
